export enum ProjectRegisterEnums {
  PROJECT_REGISTER = "Project Register",
  ADD = "ADD",
  UPDATE = "UPDATE",
  ESTIMATION = "ESTIMATION",
}

export enum ProjectRegisterStatus {
  ALL = "ALL",
  ONGOING = "ONGOING",
  WON = "WON",
  ARCHIVE = "ARCHIVE",
  UNSUCCESSFUL = "UNSUCCESSFUL",
  SUBMITTED = "SUBMITTED",
}

export enum ProjectRegisterClientType {
  CUSTOMER = "CUSTOMER",
  PROSPECT = "PROSPECT",
}

export enum ProjectRegisterActions {
  MARK_AS_WON = "Mark as Won",
  MARK_AS_ARCHIVE = "Archive",
  MARK_AS_SUBMITTED = "Mark as Submitted",
  MARK_AS_TO_DO = "Mark as To Do",
  EDIT_PROJECT_REGISTER = "Edit Project",
  MARK_AS_UNSUCCESSFUL = "Mark as Unsuccessful",
}

export enum FollowUpIntervals {
  EVERY_DAY = "EVERY_DAY",
  EVERY_WEEK = "EVERY_WEEK",
  EVERY_MONTH = "EVERY_MONTH",
}

export enum ProjectRegisterLocalStorageKeys {
  SHEET_DATA = "projectRegisterSheetData",
}
